var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("form", [
        _c("ul", { staticClass: "item-detail item-detail-simple" }, [
          _c("li", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-9 spacer-t-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { "has-error": _vm.$v.text.$error },
                    staticStyle: { margin: "0" },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "notes-redactor-editor" } },
                      [
                        _c("redactor", {
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "note_text",
                            placeholder: "Enter note text here",
                            rows: "3",
                          },
                          model: {
                            value: _vm.text,
                            callback: function ($$v) {
                              _vm.text = $$v
                            },
                            expression: "text",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.$v.text.$error
                      ? _c("span", { staticClass: "help-block" }, [
                          _vm._v("Text is required"),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-xs-12 col-md-3 spacer-t-2" },
                [
                  _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary btn-block pull-right",
                      attrs: { type: "submit", click: _vm.handleAddNote },
                    },
                    [_vm._v("\n              Add Note\n            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.firstFiveNotes, function (note) {
        return _c("notes-list-item", {
          key: note.id,
          attrs: { note: note },
          on: {
            delete: function ($event) {
              return _vm.handleDelete(note)
            },
            pin: (id) => _vm.handlePin(id),
          },
        })
      }),
      _vm._v(" "),
      _vm.viewingAll
        ? _c(
            "div",
            _vm._l(_vm.theRestOfTheNotes, function (note) {
              return _c("notes-list-item", {
                key: note.id,
                attrs: { note: note },
                on: {
                  delete: function ($event) {
                    return _vm.handleDelete(note)
                  },
                  pin: (id) => _vm.handlePin(id),
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.isMoreNotesToView
          ? _c("div", { staticClass: "col-xs-3 col-xs-push-9" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-block pull-right",
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#viewAll",
                    "aria-expanded": "false",
                    "aria-controls": "viewAll",
                  },
                  on: { click: _vm.toggleViewingAll },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.viewingAll ? "View Less" : "View All") +
                      "\n      "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }